// Query-cache entries are keyed by resource, not by who asked for them,
// so the cache must not outlive the identity that filled it. Without
// this, logging out and back in as another user in the same tab served
// the previous org's cached data (e.g. a facility overview painted for a
// residential org) until a reload. Clearing on every identity change —
// logout, login as someone else, handoff callback, refresh failure —
// covers every path that writes the session store.

import type { QueryClient } from "@tanstack/react-query";
import type { Session } from "./session";
import { currentSession, subscribe } from "./sessionStore";

function identityOf(session: Session | null): string | null {
  return session ? `${session.user.id}:${session.organization.id}` : null;
}

export function bindQueryCacheToSession(queryClient: QueryClient): () => void {
  let identity = identityOf(currentSession());
  return subscribe(() => {
    const next = identityOf(currentSession());
    if (next === identity) return; // token refresh for the same user/org
    identity = next;
    queryClient.clear();
  });
}
